module.exports = __webpack_public_path__ + "img/632f1eba4a0d2f8e6f68583b_1-p-1080.394baaaf.png";